import { Link } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "../i18n/I18nContext";

export const Footer = () => {
  const { t } = useI18n();
  return (
  <footer data-testid="site-footer" className="bg-ink text-paper/80">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-4">
        <Logo light />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/60">
          {t("footer.tagline")}
        </p>
        <div className="mt-6 space-y-2 text-sm text-paper/60">
          <p data-testid="footer-address" className="flex items-start gap-2">
            <MapPin size={15} strokeWidth={1.5} className="mt-0.5 shrink-0 text-sage" />
            {t("footer.address")}
          </p>
          <p data-testid="footer-phone" className="flex items-center gap-2">
            <Phone size={15} strokeWidth={1.5} className="shrink-0 text-sage" />
            {t("footer.phone")}
          </p>
        </div>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs uppercase tracking-[0.25em] text-paper/40">{t("footer.cabinetTitle")}</p>
        <ul className="mt-5 space-y-3 text-sm">
          <li><Link data-testid="footer-link-manifeste" to="/" className="hover:text-paper transition-colors duration-300">{t("footer.manifeste")}</Link></li>
          <li><Link data-testid="footer-link-modules" to="/#modules" className="hover:text-paper transition-colors duration-300">{t("footer.modules")}</Link></li>
          <li><Link data-testid="footer-link-simulateur" to="/simulateur" className="hover:text-paper transition-colors duration-300">{t("footer.simulateur")}</Link></li>
          <li><Link data-testid="footer-link-offres" to="/offres" className="hover:text-paper transition-colors duration-300">Offres d'emploi</Link></li>
          <li><Link data-testid="footer-link-espace" to="/espace-client" className="hover:text-paper transition-colors duration-300">{t("footer.espace")}</Link></li>
        </ul>
      </div>
      <div className="md:col-span-5">
        <p className="text-xs uppercase tracking-[0.25em] text-paper/40">{t("footer.partners")}</p>
        <p className="mt-5 text-sm leading-relaxed text-paper/60">
          {t("footer.partnersText")}
        </p>
        <p className="mt-3 font-serif italic text-lg text-paper">{t("footer.sponsor")}</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-paper/40">
        <span>© {new Date().getFullYear()} {t("footer.rights")}</span>
        <span className="font-serif italic">Vision · Autorité · Vertu</span>
      </div>
    </div>
  </footer>
  );
};
